import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormAlertComponent } from './form-alert.component';

@NgModule({
  declarations: [FormAlertComponent],
  imports: [CommonModule],
  exports: [FormAlertComponent]
})
export class FormAlertModule {}
